import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";
import CloseoutMaterial from "./CloseoutMaterial";

const CloseoutMaterialTab = ({
  attempt = {},
  getAttempt,
  isLoading = false,
  tenant,
  users = [],
}) => {
  const { classes } = useStyles();
  const issues = attempt.issues ?? [];
  const materials = issues.flatMap((issue) =>
    (issue.materialReferences ?? []).map((material) => ({
      ...material,
      issueId: issue.id,
    }))
  );

  return (
    <Box className={classes.root}>
      <CloseoutMaterial
        address={attempt.home?.address}
        communityName={attempt.home?.communityName}
        dispatcherName={attempt.dispatcherName}
        materials={materials}
        tenant={tenant}
        isLoading={isLoading}
        orderNumber={attempt.assignment?.assignmentNumber}
        orderType={attempt.assignment?.assignmentTemplateName}
        technicianName={
          attempt.assignedUserName ||
          users.find((user) => user.id === attempt.assignedUserId)?.name
        }
        performedOn={
          attempt.effectiveEndDate || attempt.endDate || attempt.modifiedOn
        }
        issues={issues}
        attemptId={attempt.id}
        assignmentId={attempt.assignment?.id}
        getAttempt={getAttempt}
        readOnly
      />
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    backgroundColor: theme.palette.grey.mediumLight,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(2),
  },
}));

export default CloseoutMaterialTab;
